<template>
  <v-app>
    <vertical-nav-menu
      :is-drawer-open.sync="isDrawerOpen"
      :is-mini="isDrawerMini"
      @update:is-mini="isDrawerMini = $event"
    ></vertical-nav-menu>

    <v-app-bar app flat absolute color="transparent">
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <v-app-bar-nav-icon
            class="d-block d-xl-none me-2"
            @click="isDrawerOpen = !isDrawerOpen"
          ></v-app-bar-nav-icon>

          <v-spacer />

          <academy-header-info class="d-none d-md-flex" />
          <theme-switcher></theme-switcher>
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <!-- Mobile academy banner - sticky at bottom -->
    <academy-header-info class="d-flex d-md-none mobile-academy-banner-sticky" />
  </v-app>
</template>

<script>
import { ref } from 'vue'
import { mdiBellOutline, mdiGithub } from '@mdi/js'
import AcademyHeaderInfo from '@/components/AcademyHeaderInfo.vue'
import VerticalNavMenu from './components/verticalNavMenu/VerticalNavMenu.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import AppBarUserMenu from './components/AppBarUserMenu.vue'

export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
    AcademyHeaderInfo,
  },

  setup() {
    const isDrawerOpen = ref(null)
    const isDrawerMini = ref(false)

    return {
      isDrawerOpen,
      isDrawerMini,

      icons: {
        mdiBellOutline,
        mdiGithub,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}

.mobile-academy-banner-sticky {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);
  border-top: 3px solid white;
}

// Add bottom padding to main content when sticky banner is visible
@media (max-width: 768px) {
  .v-main ::v-deep {
    .app-content-container {
      padding-bottom: 80px; /* Space for sticky banner */
    }
  }
}
</style>
